<template>
    <div>
        <!-- 搜索框 -->
        <a-card title="开放平台用户审核">
            <!--            <a-button slot="extra" type="primary" @click="handleNewUser">新建用户</a-button>-->
            <a-form layout="inline" :form="form">
                <a-form-item label="关键词">
                    <a-input v-model="searchP.keyword" placeholder="名称/身份证号/用户ID 关键字"></a-input>
                </a-form-item>
                <a-form-item label="名称">
                    <a-input v-model="searchP.name" placeholder="请输入名称"></a-input>
                </a-form-item>
                <a-form-item label="身份号">
                    <a-input v-model="searchP.idcardno" placeholder="请输入身份号"></a-input>
                </a-form-item>

                <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key" @click="queryUserPage">
                        搜索
                    </a-button>
                </a-form-item>
                <a-form-item>
                    <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                    </a-button>
                </a-form-item>
            </a-form>
        </a-card>

        <!-- 用户列表 -->
        <a-table :columns="columns" :data-source="msgData" :pagination="false" :loading="tLoading"
            :scroll="{ x: clientWidth }" rowKey="id">
            <template slot="operation" slot-scope="text, record">
                <span style="margin-right: 20px">
                    <router-link :to="{ path: 'edituser', query: { id: record.id } }">编辑</router-link>
                </span>
                <!-- <span> <router-link :to="{ path:'resetpassword', query: { uid: record.uid,name:record.name}}">修改密码</router-link></span> -->
            </template>

            <template slot="idImg" slot-scope="text">
                <duo-image-viewer :src="C.OSS_LOCATION + text" style="width: 100px; max-height: 120px" alt="" />
            </template>
        </a-table>
        <a-modal v-model="modalVisible" title="消息报文" @ok="handleOk">
            <json-viewer :value="currentRequest" :expand-depth="5" copyable boxed sort></json-viewer>
        </a-modal>
        <a-modal v-model="confirmVisible" title="Basic Modal" @ok="handleConfirmOk">
            {{ confirmMsg }}
        </a-modal>
        <a-pagination class="my_pagenation" v-model="pagination.page" :total="pagination.total"
            @change="handlePageChange" show-less-items show-quick-jumper />
    </div>
</template>
<script>
import JsonViewer from "vue-json-viewer";
let pagination = {
    total: 0,
    pageSize: 0,
    page: 1,
};
const columns = [
    {
        title: "序号",
        width: 100,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = pagination;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        },
    },
    {
        title: "用户ID",
        dataIndex: "uid",
        align: "left",
        width: 180,
    },
    {
        title: "名称",
        dataIndex: "name",
        align: "left",
        width: 120,
    },
    {
        title: "组织编码",
        dataIndex: "organizecode",
        align: "left",
        width: 120,
    },
    {
        title: "身份证号",
        dataIndex: "idcardno",
        align: "center",
        width: 180,
        ellipsises: true,
    },
    {
        title: "身份证照片",
        dataIndex: "idcardimg",
        scopedSlots: { customRender: "idImg" },
        align: "center",
        width: 120,
        ellipsises: true,
    },
    {
        title: "当前状态",
        dataIndex: "status",
        align: "center",
        width: 120,
        ellipsises: true,
    },
    {
        title: "到期时间",
        dataIndex: "expires",
        align: "center",
        width: 180,
        ellipsises: true,
    },
    {
        title: "剩余调用次数",
        dataIndex: "apinum",
        align: "center",
        width: 180,
        ellipsises: true,
    },

    {
        title: "操作",
        width: 150,
        scopedSlots: { customRender: "operation" },
        align: "center",
        ellipsis: true,
    },
];
const msgData = [];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            msgData,
            columns,
            searchP: {
                name: "",
                idcardno: "",
                keyword: "",
            },
            clientWidth: 800,
            pagination,
            tLoading: false,
            currentRequest: "",
            currentResponse: "",
            modalVisible: false,
            confirmVisible: false,
            confirmMsg: "",
        };
    },
    methods: {
        handleOk() {
            this.modalVisible = false;
        },

        handleParams(item) {
            this.modalVisible = true;
            try {
                this.currentRequest = JSON.parse(item.body);
            } catch (error) {
                this.currentRequest = item.body;
            }
        },

        handleConfirmOk() {
            this.searchMqInfoAndResendMessage();
            this.confirmVisible = false;
        },
        queryUserPage() {
            let c_params = {
                ...this.searchP,
                ...pagination,
                urlparams: false,
            };
            this.$store
                .dispatch({
                    type: "open/selectOpenUserinfosPage",
                    params: c_params,
                })
                .then((res) => {
                    console.log(res);
                    this.tLoading = false;
                    let result = res.data.data;
                    this.msgData = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.page = parseInt(result.page);
                    // this.searchP.total = result.totalRecords;
                    // this.searchP.pageSize = result.pageSize;
                    // this.searchP.page = result.page;
                });
        },
        handlePageChange(c_p) {
            this.pagination.page = c_p;
            this.queryUserPage();
        },
        handleSearchReset() {
            this.pagination.page = 1;
            this.searchP.name = "";
            this.searchP.idcardno = "";
            this.searchP.keyword = "";
            this.queryUserPage();
        },
        handleNewUser() {
            this.$router.push({
                path: "addUser",
            });
        },
    },

    components: {
        JsonViewer,
    },
    mounted() {
        this.queryUserPage();
    // this.getUserList();
    },
};
</script>
<style scoped>
td {
  padding: 10px 10px;
}
</style>
